import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import React, { Fragment, useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Layout from '../../components/Layout';
import { useAppDispatch, useAppSelector } from '../../redux';
import { AppDispatch } from '../../redux/store';
import { Question, useAddBreefForm } from '../../utils/forms';
import { getBreefById, getAllBreefs, getTeamsByBreefId, updateBreefAdmin } from '../../service/BreefService';
import { useTranslation } from 'react-i18next';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PageHeader from '../../components/ui/PageHeader';
import Section from '../../components/ui/Section';
import { StyledTableCell, StyledTableRow, TableWrapper } from '../../components/ui/table';


/** Dato som 23.9.2026 i stedet for 2026-09-23T08:23:00.000Z */
const danishDate = (value?: string) => (value ? new Date(value).toLocaleDateString("da-DK") : "");

const UpdateViewBreef = () => {
    const [t] = useTranslation("global");
    const [, setIsView] = useState(false)
    const [isDelete, setIsDelete] = useState(false);
    const dispatch: AppDispatch = useAppDispatch();

    const data = useAppSelector((state => state.breefs.breefData.results));
    const navigate = useNavigate();
    const { breefId }:any = useParams();
    const query = new URLSearchParams(useLocation().search);
    const isEdit = query.get('isEdit');
    const [isEditing, setIsEditing] = useState<Boolean>(isEdit === 'true'? true : false);
    const isMobile = useMediaQuery('(max-width:600px)');
    const formik = useAddBreefForm(breefId || '', isMobile);

    const [teams, setTeams] = useState<any[]>([]);
    const [isTeamsLoading, setIsTeamsLoading] = useState<boolean>(false);
    const [selectedTeam, setSelectedTeam] = useState<any>(null);
    const [isUsersModalOpen, setIsUsersModalOpen] = useState<boolean>(false);

    function handleCancel(): void {
        setIsEditing(false)
        setIsView(false)
        handleGoBack();
    }
    const handleGoBack = async () => {
        navigate(-1)
    }
    useEffect(() => {
        if (isDelete) {
            setIsDelete(false)
        }
        getAllBreefs(dispatch, isMobile, navigate);
    }, [formik.isSubmitting, isDelete])

    const fetchTeams = async () => {
        if (!breefId) return;
        setIsTeamsLoading(true);
        try {
            const teamData = await getTeamsByBreefId(breefId, isMobile, navigate);
            if (Array.isArray(teamData)) {
                setTeams(teamData);
            }
        } catch (err) {
            console.error("Error fetching breef teams:", err);
        } finally {
            setIsTeamsLoading(false);
        }
    };

    useEffect(() => {
        fetchTeams();
    }, [breefId]);

    const handleTeamClick = (team: any) => {
        setSelectedTeam(team);
        setIsUsersModalOpen(true);
    };

    const handleCloseUsersModal = () => {
        setIsUsersModalOpen(false);
        setSelectedTeam(null);
    };

    const handleSubmit = async(e: React.FormEvent<HTMLFormElement>) => {
        console.log("Entered here", formik.values);
        
        e.preventDefault();
        await updateBreefAdmin(breefId, formik.values);
        // formik.handleSubmit(e as any);
        setIsEditing(false)
        setIsView(false);
    };
    const setUpBreef = async () => {
        // Hent breefen direkte, hvis den ikke er på den indlæste liste (fx en ny breef)
        const fromList = (data || []).filter((breef) => breef.id === breefId);
        const breef: any[] = fromList.length ? fromList : [await getBreefById(breefId || '')].filter(Boolean);
        if (!breef || breef.length === 0) return;
        const mappedQuestions = breef[0].questions?.map((question: any) => {
            return {
                question: question.question,
                options: question.options,
                answer: question.answer
            };
        }) || [];
        formik.setValues({
            period:breef[0].period,
            expiry:breef[0].expiry,
            breefName: breef[0].breefName,
            gameId: typeof breef[0].gameId === 'string' ? breef[0].gameId : (breef[0].gameId?.id || ''),
            questions: mappedQuestions,
            status: breef[0].status,
            tenantId: typeof breef[0].tenantId === 'string' ? breef[0].tenantId : (breef[0].tenantId?.id || ''),
            videoUrl: breef[0].videoUrl,
            gameName: breef[0].gameId?.gameName || '',
            tenantName: breef[0].tenantId ? (breef[0].tenantId.firstName + " " + breef[0].tenantId.lastName) : ''
        });
    }
    useEffect(() => {
        setUpBreef();
    }, [breefId, isEdit, data])
    useEffect(() => {
        console.log("is edit ", isEdit)
    }, [])
    return (
        <Layout>
            <PageHeader
                title={`${isEdit === 'true' ? t("common.edit") : t("common.view")} Breef`}
                actions={
                    <>
                        <Button onClick={handleCancel} startIcon={<ArrowBackIcon />}>
                            {t("common.back")}
                        </Button>
                        {isEditing && (
                            <Button type="submit" form="breef-form" variant="contained">
                                {t('updatebreef.t2')}
                            </Button>
                        )}
                    </>
                }
            />

            <Box component="form" id="breef-form" onSubmit={handleSubmit}>
                <Section title={t("breefView.basics")}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField fullWidth id="breefName" name="breefName" InputLabelProps={{ shrink: true }} label={t("fields.breefName")} variant="outlined"
                                onChange={formik.handleChange("breefName")} value={formik.values.breefName}
                                error={formik.touched.breefName && Boolean(formik.errors.breefName)}
                                helperText={formik.touched.breefName && formik.errors.breefName}
                                disabled={isEdit !== 'true'} />
                        </Grid>
                        <Grid item xs={6} sm={3} md={2}>
                            <TextField fullWidth name="period" InputLabelProps={{ shrink: true }} label={t("fields.startDate")} variant="outlined" value={danishDate(formik.values.period)} disabled />
                        </Grid>
                        <Grid item xs={6} sm={3} md={2}>
                            <TextField fullWidth name="expiry" InputLabelProps={{ shrink: true }} label={t("fields.endDate")} variant="outlined" value={danishDate(formik.values.expiry)} disabled />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField fullWidth id="tenantName" name="tenantName" InputLabelProps={{ shrink: true }} label={t("fields.tenantName")} variant="outlined" value={formik.values.tenantName} disabled />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField fullWidth id="gameName" name="gameName" InputLabelProps={{ shrink: true }} label={t("fields.gameName")} variant="outlined" value={formik.values.gameName} disabled />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField fullWidth id="status" name="status" InputLabelProps={{ shrink: true }} label={t("fields.status")} variant="outlined"
                                onChange={formik.handleChange("status")} value={t(`breefStatus.${formik.values.status}`, formik.values.status)} disabled={isEdit !== 'true'} />
                        </Grid>
                    </Grid>
                </Section>

                <Section title={t("breefView.video")}>
                    {formik.values.videoUrl ? (
                        <Box sx={{ maxWidth: 640 }}>
                            <ReactPlayer url={formik.values.videoUrl} width="100%" height="auto" controls light />
                        </Box>
                    ) : (
                        <Typography variant="body2" color="text.secondary">{t("breefView.noVideo")}</Typography>
                    )}
                </Section>

                <Section title={t("breefView.questions")}>
                    {formik.values.questions.map((question: Question, index: number) => (
                        <Box key={index} sx={{ mb: 3, pb: 3, borderBottom: index < formik.values.questions.length - 1 ? '1px solid' : 0, borderColor: 'divider' }}>
                            <TextField fullWidth id={`question-${index}`} label={t("breefView.question", { number: index + 1 })} variant="outlined" sx={{ mb: 2 }}
                                onChange={formik.handleChange(`questions[${index}].question`)}
                                value={formik.values.questions[index].question} disabled={isEdit !== 'true'} />
                            <Grid container spacing={2}>
                                {question.options.map((option, optionIndex: number) => {
                                    const isAnswer = formik?.values?.questions[index].options[optionIndex] === String(formik.values.questions[index].answer);
                                    return (
                                        <Grid item xs={12} sm={6} key={optionIndex}>
                                            <TextField fullWidth id={`question-${index}-option-${optionIndex}`}
                                                label={isAnswer ? t("breefView.rightAnswer") : t("breefView.wrongAnswer")}
                                                variant="outlined"
                                                color={isAnswer ? "success" : undefined}
                                                focused={isAnswer || undefined}
                                                onChange={formik.handleChange(`questions[${index}].options[${optionIndex}]`)}
                                                value={formik.values.questions[index].options[optionIndex]} disabled={isEdit !== 'true'} />
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </Box>
                    ))}
                </Section>
            </Box>

            <Section title={t("breefView.teams")}>
                {isTeamsLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                        <CircularProgress size={24} />
                    </Box>
                ) : teams && teams.length > 0 ? (
                    <TableWrapper>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>{t("teamtable.teamName", "Hold")}</StyledTableCell>
                                    <StyledTableCell align="center">{t("breefView.members")}</StyledTableCell>
                                    <StyledTableCell align="center">{t("tracking.actions")}</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {teams.map((team: any) => (
                                    <StyledTableRow key={team.id || team._id} hover sx={{ cursor: 'pointer' }} onClick={() => handleTeamClick(team)}>
                                        <TableCell>{team.teamName}</TableCell>
                                        <TableCell align="center">{team.members !== undefined ? team.members : (team.membersName ? team.membersName.length : 0)}</TableCell>
                                        <TableCell align="center">
                                            <Button size="small" startIcon={<VisibilityIcon />} onClick={(e) => { e.stopPropagation(); handleTeamClick(team); }}>
                                                {t("breefView.viewMembers")}
                                            </Button>
                                        </TableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableWrapper>
                ) : (
                    <Typography variant="body2" color="text.secondary">{t("breefView.noTeams")}</Typography>
                )}
            </Section>

            <Dialog open={isUsersModalOpen} onClose={handleCloseUsersModal} maxWidth="md" fullWidth>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {selectedTeam ? t("breefView.membersIn", { team: selectedTeam.teamName }) : t("breefView.members")}
                    <IconButton onClick={handleCloseUsersModal}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {selectedTeam?.membersName && selectedTeam.membersName.length > 0 ? (
                        <TableWrapper>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>{t("manageUsers.name", "Navn")}</StyledTableCell>
                                        <StyledTableCell>{t("managetenant.t21")}</StyledTableCell>
                                        <StyledTableCell align="center">{t("manageUsers.totalScore", "Score")}</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedTeam.membersName.map((user: any, idx: number) => (
                                        <StyledTableRow key={user._id || user.id || idx} hover>
                                            <TableCell>{[user.firstName, user.lastName].filter(Boolean).join(' ') || '-'}</TableCell>
                                            <TableCell>{user.phoneNumber || '-'}</TableCell>
                                            <TableCell align="center">{user.totalScore !== undefined ? user.totalScore : '0'}</TableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableWrapper>
                    ) : (
                        <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>{t("breefView.noMembers")}</Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseUsersModal}>{t("breefView.close")}</Button>
                </DialogActions>
            </Dialog>
        </Layout>
    )
}

export default UpdateViewBreef